import { ClassifierType } from '../classifier/classifier.model';
import { ImportFile, ImportScan } from './import.models';

export class SetCombineToSingleScan {
  static readonly type = '[ImportState] SetCombineToSingleScan';
  constructor(public combineToSingleScan: boolean) {}
}

export class SetRunClassifier {
  static readonly type = '[ImportState] SetRunClassifier';
  constructor(public runClassifier: boolean) {}
}

export class SetClassifierType {
  static readonly type = '[ImportState] SetClassifierType';
  constructor(public classifierType: ClassifierType) {}
}

export class AddToImportScans {
  static readonly type = '[ImportState] AddToImportScans';
  constructor(public importScans: ImportScan[]) {}
}

export class PatchImportScan {
  static readonly type = '[ImportState] PatchImportScan';
  constructor(public importScan: ImportScan) {}
}

export class PatchImportFile {
  static readonly type = '[ImportState] PatchImportFile';
  constructor(public importFile: ImportFile) {}
}

export class ResetImportScans {
  static readonly type = '[ImportState] ResetImportScans';
}
